import { useState } from "react";
import { Interest } from "../../store/domains/Interest";
import { Api } from "../../common/Api";

export const useInterests = () => {
  const [interests, setInterests] = useState<Interest[]>([]);
  const [loading, setLoading] = useState(false);
  const [openEditDlg, setOpenEditDlg] = useState(false);
  const [saving, setSaving] = useState(false);

  const groups = interests.reduce((pre: any[], it: any) => {
    let g = pre.find((x) => x.groupName === it.groupName);
    if (!g) {
      pre.push({ groupName: it.groupName, children: [it] });
    } else {
      g.children.push(it);
    }
    return pre;
  }, []);

  const refresh = () => {
    setLoading(true);
    Api.interest
      .list()
      .then((res) => {
        setInterests(res.data.interests);
      })
      .finally(() => setLoading(false));
  };

  const check = (groupName, name) => {
    return Api.interest.check({ groupName, name }).then((res) => res.data.checkInterest);
  };

  const save = (values) => {
    setSaving(true);
    return Api.interest
      .add({ ...values })
      .then((res) => {
        setOpenEditDlg(false);
        refresh();
      })
      .finally(() => setSaving(false));
  };

  return { groups, loading, refresh, openEditDlg, setOpenEditDlg, saving, save, check };
};
